import type { EntityId } from '../../types/constants'

export const SET_PAYLOAD = 'SET_PAYLOAD'
export const SET_MODAL_DATA = 'SET_MODAL_DATA'
export const SET_OUT_OF_SYNC_IDS = 'SET_OUT_OF_SYNC_IDS'
export const SHOW_BULK_ACTION_MODAL = 'SHOW_BULK_ACTION_MODAL'
export const HIDE_BULK_ACTION_MODALS = 'HIDE_BULK_ACTION_MODALS'

export interface SetPayload {
    type: typeof SET_PAYLOAD
    payload: any
    receivedAt: number
}

export interface SetOutOfSyncIds {
    type: typeof SET_OUT_OF_SYNC_IDS
    outOfSyncIds: EntityId[]
    receivedAt: number
}

export interface SetModalData {
    type: typeof SET_MODAL_DATA
    data: any
    receivedAt: number
}

export interface ShowBulkActionModal {
    type: typeof SHOW_BULK_ACTION_MODAL
    modal: string
    receivedAt: number
}

export interface HideBulkActionModals {
    type: typeof HIDE_BULK_ACTION_MODALS
    receivedAt: number
}

export type BulkActionAction =
    | SetPayload
    | SetOutOfSyncIds
    | SetModalData
    | ShowBulkActionModal
    | HideBulkActionModals
